import React from "react";
import SidebarAdmin from "../components/admin/sidebarAdmin";
import { Outlet } from "react-router-dom";

export default function AdminLayout() {
  return (
    <div className="d-flex flex-column flex-lg-row" style={{ minHeight: "100vh" }}>
      <SidebarAdmin />
      <main className="flex-grow-1 p-3">
        <div className="d-lg-none" style={{ height: "60px" }}></div>
        <Outlet />
      </main>
    </div>
  );
}
